import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../stateless/SnackBarProvider';
import { useResetPasswordApi } from '../../Hooks/useResetPasswordApi';


export const useResetPassword = () => {
  //   const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createResetPassword } = useResetPasswordApi();
  return useMutation({
    mutationKey: ['CreateChoice'],
    mutationFn: (data: any) => createResetPassword(data),
    onSuccess: (response: any) => {
      showMessage(response?.message || 'OPT Verified successfully', 'success');
    },
    onError: (error: any) => {
      showMessage(error.response?.data?.message || 'Incorrect OPT', 'error');
    },
  });
};
